import React, { Component } from 'react';
import { validateEmail } from '../../helpers/validations';

import MainButton from '../buttons/mainButton';

import { FiPhone, FiMail } from 'react-icons/fi';


import './contactForm.css'

class ContactForm extends Component {

  state = {
    warning: "none",
  }

  renderEmailPlaceholder(data) {
    if (data.url.length === 0) {
      return `email@${data.name}.com`
    } else {
      return `email@${data.url}`
    }
  }

  canBeSubmitted() {
    return validateEmail(this.props.email) /* && this.props.optin*/ === true
  }

  showWarning() {
    if (!validateEmail(this.props.email) /*&& this.props.optin*/ === true) {
      this.setState({warning: "email"})
    } /* else if (!validateEmail(this.props.email) && this.props.optin === false) {
      this.setState({warning: "both"})
    } else if (validateEmail(this.props.email) && this.props.optin === false) {
      this.setState({warning: "optin"})
    }*/
  }

  handleSubmit() {
    if (this.canBeSubmitted() === true) {
      this.setState({warning: "none"})
      this.props.saveResultsToDatabase()
    } else {
      this.showWarning()
    }
  }


  render() {

    return(
      <div className="contact-input-container">
        <h3>{this.props.copy.headline}</h3>
        <div className="input-group">
          <FiMail size="22" color="#F39200" style={{padding: '13px 5px 10px 0px'}}/>
          <input
            placeholder={this.renderEmailPlaceholder({url: this.props.companyUrl, name: this.props.companyName})}
            className="contact-input"
            value={this.props.email}
            onChange={(event) => this.props.updateEmail(event.target.value)}
          />
        </div>

        <div className="input-group">
          <FiPhone size="22" color="#F39200" style={{padding: '13px 5px 10px 0px'}}/>
          <input
            placeholder={this.props.copy.optional}
            className="contact-input"
            value={this.props.phone}
            onChange={(event) => this.props.updatePhone(event.target.value)}
          />
        </div>

        <label className="container" style={{display: 'none'}}>
          Hiermit willige ich ein, dass Sie mich zum Zweck einer Beratung kontaktieren.
          <input
            type="checkbox"
            value={this.props.optin}
            onChange={() => this.props.updateOptin()}
          >
          </input>
          <span className="checkmark"></span>
        </label>

        {this.state.warning === "email" && <div className="warning-box">Fehler: bitte korrekte eMail-Adresse eingeben.</div>}
        {this.state.warning === "both" && <div className="warning-box">Fehler: bitte korrekte eMail-Adresse eingeben und Einwilling abgeben.</div>}
        {this.state.warning === "optin" && <div className="warning-box">Fehler: bitte Einwilligung abgeben.</div>}

        <div style={{marginTop: '40px'}}>
          <MainButton
            action={() => this.handleSubmit()}
            label={this.props.copy.button}
          />
        </div>

        <div className="optin-box">
          {this.props.copy.legal}
        </div>

      </div>

    )
  }
}

export default ContactForm;
